module.exports = __webpack_public_path__ + "media/images/client/AdCatalog/banner-closed-access-ae68372c36bcb0551a70ca55e50d7b6c.svg";